<template>
	<div class='reply'>
		<a class='author-photo' v-if='reply.created_by.photo_small' :href='`/profile/${reply.created_by.id}/`'>
			<img :src='reply.created_by.photo_small' >
		</a>
		<div class='author-comment'>
			<div class='author-comment-data-wrapper'>
				<a class='name' :href='`/profile/${reply.created_by.id}/`'>
					{{reply.created_by.name}}
				</a>
				<div class='comment-text'>
					{{reply.text}}
				</div>
				<div class='comment-text'>
					<img class='img-wrapper'
						:src='photo.image'
						v-for='(photo, p) in reply.attachments'
						:key='`p-${p}`'
					>
				</div>
			</div>
			<div class='actions'>
				<div v-if="showDeleteBtn" class='reply comment__delete-btn-reply' @click="deleteComment()">Delete</div>
				<div class='time'>
					• {{reply.created_at|formatDate}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import global from '__jsVueMixin/global';
import api from '__jsVueApi';
import EventBus from '__jsEbentBus';
export default {
	name:   'Reply',
	mixins:     [global],
	props:  {
		reply: {
			type: Object
		},
		postId: Number
	},
	computed: {
		showDeleteBtn() {
			return this.reply.is_owner || this.profile.is_admin;
		},
		profile() {
			return this.$store.state.profile.profile;
		},
	},
	methods: {
		async deleteComment() {
			EventBus.$emit('confirm', {
				onOk: () => {
					axios.delete(api.posts.comments.replyDelete(this.reply.id)).then(async(response) => {
						this.$toastr.i('<div class="toastr"><div class="toastr__check"></div><p class="toastr__text">Reply has been deleted</p></div>');
						EventBus.$emit('reply-delete', { postId: this.postId, replyId: this.reply.id, commentId: this.reply.comment });
					});
				},
				message: 'Do you really want to delete this reply?'
			});
		},
	}
};
</script>
